<aside class="text-white sen-label-font-size h-100" fxLayout="column">
    <div class="bg-white sen-logo" fxLayout="column" fxLayoutAlign="center center">
        <img src="assets/images/sen-logo.png" width="75">
    </div>
    <div class="sen-main-menu" fxLayout="column" fxFlex="1 1 auto">
        <div class="sen-project-menu" fxLayout="column" fxFlex="1 1 auto" fxLayoutAlign="space-even stretch">
            <div *ngFor="let item of navMainItems" (click)="navigateToMPPath(item.link)"
                [class.sen-active-main-menu]="router.isActive(item.link, false)" class="py-3 text-center"
                [ngClass]="item.label == navMainItems[0].label ? 'sen-cursor-pointer' : 'sen-no-pointer'">
                <img src="{{item.image}}"><br>
                <span class="d-inline-block sen-menu-title mt-2">{{translate.getLng(item.label)}}</span>
            </div>
        </div>
        <div class="sen-other-menu text-center" fxLayout="column" fxLayoutAlign="center stretch">
            <!-- <div [routerLink]="[settingsPath]" class="py-3 sen-cursor-pointer" routerLinkActive="sen-active-main-menu">
                <img src="assets/images/menu_icon_settings.png">
            </div> -->
            <div class="py-3 sen-cursor-pointer" (click)="navigateToSetting()">
                <img src="assets/images/menu_icon_settings.png">
            </div>
            <div class="mt-3 sen-cursor-pointer">
                <img src="assets/images/menu_icon_help.png">
            </div>
        </div>
    </div>
</aside>